export const decodeEntities = (text: string) => {
  const entities = [
    ['#8217', '’'],
    ['#8216', '‘'],
    ['#038', '&'],
    ['amp', '&'],
    ['#8211', '–'],
  ];
  entities.forEach((item) => {
    text = text.replace(new RegExp(`&${item[0]};`, 'g'), item[1]);
  });
  return text;
};
